var exports = {
  "k": "xfb577c5e--a09732--container",
};

module.exports = exports;
